"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ TOOLBAR ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Section = function Section(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      actions = _ref.actions,
      tools = _ref.tools; // 2.1. FUNCTIONS ............................................................
  // 2.1.1. RENDER TEXT

  var renderContent = function renderContent(H, D) {
    if (H || D) {
      return _react["default"].createElement(_index.ToolbarContent, null, H && _react["default"].createElement("h1", null, H), D && _react["default"].createElement("p", null, D));
    }
  }; // 2.1.1. END
  // 2.1.2. RENDER ACTIONS


  var renderActions = function renderActions(A) {
    return _react["default"].createElement(_index.ToolbarActions, null, A.map(function (action) {
      return _react["default"].createElement("li", null, action);
    }));
  }; // 2.1.2. END
  // 2.1.3. RENDER TOOLS


  var renderTools = function renderTools(T) {
    return _react["default"].createElement(_index.ToolbarRow, null, T);
  }; // 2.1.3. END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................


  return _react["default"].createElement(_index.ToolbarContainer, null, renderContent(heading, description), actions && renderActions(actions), tools && renderTools(tools)); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


Section.defaultProps = {
  heading: '',
  description: '',
  footer_heading: '',
  footer_cta: '',
  footer_url: ''
}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

Section.propTypes = {
  /**  Contents within this component. */
  children: _propTypes["default"].node,

  /**  Section heading. */
  heading: _propTypes["default"].string,

  /**  Section description. */
  description: _propTypes["default"].string,

  /**  Footer heading. */
  footer_heading: _propTypes["default"].string,

  /**  Footer CTA. */
  footer_cta: _propTypes["default"].string,

  /**  CTA URL */
  footer_url: _propTypes["default"].string
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Section; // END OF FILE #################################################################

exports["default"] = _default;